
<div class="frontPagination">
  <ul class="frontPagination__list">
    <li v-if="pager.hasPrev()" class="frontPagination__listItem">
        <a :href="pageLink(pager.currentPage - 1)">&lt;</a>
    </li>
    <li v-for="(page, index) in paginationLinks" :key="`page-${index}`" class="frontPagination__listItem">
      <a v-if="page !== '' && page !== pager.currentPage"
         :href="pageLink(page)">
        {{ page }}
      </a>
      <span v-else-if="page === pager.currentPage" class="active">
        {{ page }}
      </span>
      <span v-else>…</span>
    </li>
    <li v-if="pager.hasNext()" class="frontPagination__listItem">
        <a :href="pageLink(pager.currentPage + 1)">&gt;</a>
    </li>
   </ul>
</div>
